// Mock data per Alt Bollette

export const servizi = [
  {
    id: 1,
    titolo: "Impianti Fotovoltaici",
    descrizione: "Pannelli solari ad alta efficienza progettati su misura per la tua casa, per massimizzare la produzione energetica e azzerare i costi di luce.",
    icon: "Sun",
    beneficio: "Fino al 90% di risparmio sulla bolletta elettrica"
  },
  {
    id: 2,
    titolo: "Sistemi di Accumulo",
    descrizione: "Batterie di ultima generazione che immagazzinano l'energia prodotta per garantirti autonomia completa 24 ore su 24, 7 giorni su 7.",
    icon: "Battery",
    beneficio: "Energia disponibile anche di notte e nei giorni nuvolosi"
  },
  {
    id: 3,
    titolo: "Microeolico Domestico",
    descrizione: "Turbine eoliche compatte che sfruttano il vento per generare elettricità pulita, integrando perfettamente il tuo sistema fotovoltaico.",
    icon: "Wind",
    beneficio: "Produzione energetica costante anche senza sole"
  },
  {
    id: 4,
    titolo: "Pompe di Calore",
    descrizione: "Sistemi ecosostenibili per riscaldamento e raffrescamento che riducono drasticamente i consumi di gas, alimentati dalla tua energia rinnovabile.",
    icon: "Thermometer",
    beneficio: "Elimina i costi del gas per riscaldamento"
  },
  {
    id: 5,
    titolo: "Sistemi Termodinamici",
    descrizione: "Tecnologia avanzata per produrre acqua calda sanitaria gratuita tutto l'anno, indipendentemente dalle condizioni meteo.",
    icon: "Droplets",
    beneficio: "Acqua calda gratuita 365 giorni l'anno"
  }
];

export const processoSteps = [
  {
    numero: 1,
    titolo: "Analisi Gratuita",
    descrizione: "Studiamo la tua abitazione, i consumi energetici e le caratteristiche del tetto per progettare la soluzione ottimale.",
    icon: "ClipboardCheck"
  },
  {
    numero: 2,
    titolo: "Progetto Personalizzato",
    descrizione: "Creiamo un sistema energetico su misura che integra le tecnologie più adatte alle tue esigenze specifiche.",
    icon: "FileText"
  },
  {
    numero: 3,
    titolo: "Installazione Professionale",
    descrizione: "Il nostro team esperto installa il sistema completo senza che tu debba anticipare nulla. Zero costi iniziali.",
    icon: "Wrench"
  },
  {
    numero: 4,
    titolo: "Autofinanziamento",
    descrizione: "Il sistema si paga da solo grazie al risparmio immediato sulle bollette. Inizi a risparmiare dal primo giorno.",
    icon: "TrendingUp"
  },
  {
    numero: 5,
    titolo: "Bollette Azzerate",
    descrizione: "Goditi l'indipendenza energetica totale con energia pulita, sostenibile e a costo zero per i prossimi 25+ anni.",
    icon: "CheckCircle"
  }
];

export const differenziatori = [
  {
    titolo: "Progetti Personalizzati",
    descrizione: "Ogni sistema è unico, progettato specificamente per le caratteristiche della tua casa e le tue esigenze energetiche.",
    icon: "Users"
  },
  {
    titolo: "Garanzia Scritta",
    descrizione: "Garantiamo per iscritto i risultati di efficientamento energetico e risparmio che otterrai.",
    icon: "Shield"
  },
  {
    titolo: "Nessun Anticipo",
    descrizione: "Zero costi iniziali. Inizi a risparmiare immediatamente senza dover investire il tuo capitale.",
    icon: "Banknote"
  },
  {
    titolo: "Soluzioni Integrate",
    descrizione: "Non solo fotovoltaico: offriamo sistemi completi che integrano accumulo, pompe di calore e molto altro.",
    icon: "Boxes"
  },
  {
    titolo: "Assistenza Dedicata",
    descrizione: "Un referente personale ti segue in ogni fase, dall'analisi iniziale alla manutenzione nel tempo.",
    icon: "Headphones"
  }
];

export const vantaggiFranchising = [
  {
    titolo: "Investimento Zero",
    descrizione: "Avvia la tua attività nel settore delle energie rinnovabili senza costi di ingresso. Paghi solo in base ai risultati.",
    icon: "DollarSign"
  },
  {
    titolo: "Esclusiva Territoriale",
    descrizione: "Ottieni l'esclusiva nella tua zona di competenza, senza concorrenza interna al network.",
    icon: "MapPin"
  },
  {
    titolo: "Formazione Completa",
    descrizione: "Ti forniamo tutta la formazione tecnica e commerciale necessaria per avere successo nel settore.",
    icon: "GraduationCap"
  },
  {
    titolo: "Supporto Marketing",
    descrizione: "Materiali promozionali, campagne digitali e supporto alla vendita per generare lead costantemente.",
    icon: "Megaphone"
  },
  {
    titolo: "Mercato in Crescita",
    descrizione: "Il settore delle rinnovabili è in espansione esponenziale. È il momento perfetto per entrare.",
    icon: "TrendingUp"
  },
  {
    titolo: "Modello Provato",
    descrizione: "Sistema di business già testato e ottimizzato, con processi consolidati e risultati dimostrati.",
    icon: "Award"
  }
];

// Mock function per salvare lead
export const salvaLead = async (leadData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Lead salvato (mock):", leadData);
      resolve({ success: true, message: "Grazie! Ti contatteremo entro 24 ore." });
    }, 1000);
  });
};

// Mock function per calcolare risparmio
export const calcolaRisparmio = (dati) => {
  const { bollettaLuce, bollettaGas, superficieTetto, orientamento, ombreggiamento } = dati;
  
  // Calcolo semplificato per demo
  const fattoreOrientamento = orientamento === 'sud' ? 1.0 : orientamento === 'est-ovest' ? 0.85 : 0.7;
  const fattoreOmbreggiamento = ombreggiamento === 'no' ? 1.0 : ombreggiamento === 'parziale' ? 0.8 : 0.6;
  
  const potenzaInstallabile = (superficieTetto / 5) * fattoreOrientamento * fattoreOmbreggiamento;
  const produzioneAnnua = potenzaInstallabile * 1300; // kWh/anno stimati
  
  const risparmioLuce = Math.min(bollettaLuce * 12, produzioneAnnua * 0.15);
  const risparmioGas = bollettaGas * 12 * 0.7; // Con pompa di calore
  const risparmioTotale = risparmioLuce + risparmioGas;
  
  const costoImpianto = potenzaInstallabile * 1500;
  const tempoRientro = costoImpianto / risparmioTotale;
  const risparmio25anni = risparmioTotale * 25;
  
  return {
    potenzaKw: potenzaInstallabile.toFixed(1),
    produzioneAnnua: Math.round(produzioneAnnua),
    risparmioAnno: Math.round(risparmioTotale),
    risparmioMese: Math.round(risparmioTotale / 12),
    risparmio25anni: Math.round(risparmio25anni),
    tempoRientro: tempoRientro.toFixed(1),
    costoStimato: Math.round(costoImpianto)
  };
};
